import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip"; // Ensure Tooltip is imported
import Icons from "../../../Config/Images";
import "./CustomerReview.css";
import CustomImageComponent from "../CustomComponents/CustomImageComponent";
import { useSwipeable } from "react-swipeable";

// const reviews = [
//   // Your review data
//   // (same as before)
//   {
//     name: "Neel",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText:
//       "Delivery And Product Is Good Delivery And Product Is Good Delivery And Product Is Good Delivery And Product Is Good Delivery And Product Is Good",
//     image: Icons.bangleimage,
//   },
//   {
//     name: "Aakash",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.neckLaceSetImage,
//   },
//   {
//     name: "Siddharth",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.goldRingImage,
//   },
//   {
//     name: "Abhishek",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.bangleimage,
//   },
//   {
//     name: "Chetna",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.neckLaceSetImage,
//   },
//   {
//     name: "Kunal",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.goldRingImage,
//   },
//   {
//     name: "Shivam",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.bangleimage,
//   },
//   {
//     name: "Shivam1",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.bangleimage,
//   },
//   {
//     name: "Shivam2",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.bangleimage,
//   },
//   {
//     name: "Shivam3",
//     date: "09/09/2024",
//     rating: 5,
//     reviewText: "Delivery And Product Is Good",
//     image: Icons.bangleimage,
//   },
// ];

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
};
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
const ReviewCard = ({ name, date, rating, reviewText, image }) => {
  // const maxLength = 85;
  const maxLength = 35;
  const showTooltip = reviewText.length > maxLength; // Determine if tooltip should be shown
  const TOTAL_STARS = 5;

  return (
    <div className="card" sx={{ height: 395, borderRadius: "10px" }}>
      {/* <CardMedia component="img" height="220" image={image} alt="review" /> */}
      {/* <CustomImageComponent
        src={image}
        // alt="review"
        height="220px"
        width="100%"
        fallbackSrc={Icons.blank_image} // fallback from your config
        objectFit="cover"
        backgroundColor="#f8f8f8"
      /> */}
      <CardContent>
        <div
          className="lowerDivContent"
          style={{
            textAlign: "left",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              // variant="h6"
              // component="h3"
              // sx={{ fontWeight: 600, color: "#181818" }}
              className="name-review-card"
            >
              {name}
            </div>
            <Typography
              variant="body2"
              sx={{ color: "#727272", marginTop: "4px" }}
            >
              {formatDate(date)}
            </Typography>
            <div
              className="stars"
              style={{ marginTop: "5px", display: "flex", gap: "4px" }}
            >
              {/* {Array.from({ length: rating }, (_, i) => (
                <img
                  key={i}
                  src={Icons.activeStarIcon}
                  alt="star"
                  style={{ height: "19px", width: "20px" }}
                />
              ))} */}
              {Array.from({ length: 5 }).map((_, index) => {
                const isActive = index < rating;

                return (
                  <img
                    key={index}
                    src={Icons.activeStarIcon}
                    alt="star"
                    className={`star ${isActive ? "active" : "inactive"}`}
                  />
                );
              })}
            </div>
          </div>
          <div>
            <CustomImageComponent
              style={{ borderRadius: "50%" }}
              width={"60px"}
              height={"60px"}
              src={image}
            />
          </div>
        </div>
        <div style={{ textAlign: "left" }}>
          {showTooltip ? (
            <Tooltip
              title={reviewText}
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    color: "#fff",
                    fontSize: "13px",
                    borderRadius: "4px",
                    padding: "8px 12px",
                    maxWidth: "300px",
                    wordWrap: "break-word",
                  },
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  marginTop: "5px",
                  fontFamily: "'Poppins', sans-serif",
                  cursor: "pointer",
                  maxWidth: "140px",
                }}
              >
                {truncateText(reviewText, maxLength)}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              variant="body2"
              sx={{
                marginTop: "5px",
                fontFamily: "'Poppins', sans-serif",
                cursor: "pointer",
                maxWidth: "140px",
              }}
            >
              {truncateText(reviewText, maxLength)}
            </Typography>
          )}
        </div>
      </CardContent>
    </div>
  );
};

const CustomerReview = ({ feedbackRatings }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  // const itemsPerPage = 6;
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [isMobile, setIsMobile] = useState(false);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    setReviews(feedbackRatings);
  }, [feedbackRatings]);

  useEffect(() => {
    const updateItemsPerPage = () => {
      const width = window.innerWidth;

      setIsMobile(width < 490);
      if (width <= 700) {
        setItemsPerPage(1);
      } else if (width <= 700) {
        setItemsPerPage(2);
      } else if (width <= 1050) {
        setItemsPerPage(3);
      } else if (width <= 1440) {
        setItemsPerPage(4);
      } else if (width <= 1600) {
        setItemsPerPage(5);
      } else {
        setItemsPerPage(6);
      }
    };

    updateItemsPerPage(); // Initial check
    window.addEventListener("resize", updateItemsPerPage);
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);
  // Calculate the index range to display
  const displayedReviews = reviews?.slice(
    currentIndex,
    currentIndex + itemsPerPage
  );
  // const displayedReviews = isMobile
  //   ? reviews // Show all items on mobile so they can scroll freely
  //   : reviews?.slice(currentIndex, currentIndex + itemsPerPage);
  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      Math.min(prevIndex + 1, reviews?.length - itemsPerPage)
    );
  };

  // const swipeHandlers = useSwipeable({
  //   onSwipedLeft: () => {
  //     if (!isMobile) return;
  //     handleNextClick();
  //   },
  //   onSwipedRight: () => {
  //     if (!isMobile) return;
  //     handlePrevClick();
  //   },
  // });

  return (
    <div className="customerReviewDiv">
      <div className="upperContent">
        <h1>Customer Reviews</h1>
      </div>
      <div className="lowerContent">
        <div
          className="hrLine"
          style={{
            width: "100%",
            height: "2px",
            marginBottom: "30px",
            backgroundColor: "#9C7726",
          }}
        ></div>

        {reviews.length >= itemsPerPage && (
          // <div className="arrow-review leftArrow" onClick={handlePrevClick}>
          //   <img src={Icons.leftSliderArrowIcon} alt="left arrow" />
          // </div>
          <div
            className={`arrow-review leftArrow ${
              currentIndex === 0 ? "disabled" : ""
            }`}
            onClick={currentIndex > 0 ? handlePrevClick : undefined}
            style={{
              cursor: currentIndex === 0 ? "not-allowed" : "pointer",
              opacity: currentIndex === 0 ? 0.5 : 1,
            }}
          >
            <img src={Icons.leftSliderArrowIcon} alt="left arrow" />
          </div>
        )}
        <div className="cardsMainDivCustomerReviewDiv">
          {displayedReviews.map((review, index) => (
            <ReviewCard
              key={index}
              name={review.user_first_name + " " + review.user_last_name}
              date={review.created_at}
              rating={review.feedback_rating}
              reviewText={review.feedback_message}
              image={review.user_profile_image_url}
            />
          ))}
        </div>
        {reviews.length >= itemsPerPage && (
          // <div className="arrow-review rightArrow" onClick={handleNextClick}>
          //   <img src={Icons.rightSliderArrowIcon} alt="right arrow" />
          // </div>

          <div
            className={`arrow-review rightArrow ${
              currentIndex + itemsPerPage >= reviews.length ? "disabled" : ""
            }`}
            onClick={
              currentIndex + itemsPerPage < reviews.length
                ? handleNextClick
                : undefined
            }
            style={{
              cursor:
                currentIndex + itemsPerPage >= reviews.length
                  ? "not-allowed"
                  : "pointer",
              opacity: currentIndex + itemsPerPage >= reviews.length ? 0.5 : 1,
            }}
          >
            <img src={Icons.rightSliderArrowIcon} alt="right arrow" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerReview;
